import { Reveal, Eyebrow } from "@/components/Reveal";
import {
  Globe, Rocket, User, ShoppingCart, AppWindow,
  RefreshCcw, Wrench, PenLine, Gauge, Search, ArrowUpRight,
} from "lucide-react";
import { scrollToId } from "@/lib/api";

const SERVICES = [
  { icon: Globe, title: "Business Websites", desc: "Complete, professional websites that present your business with credibility.", span: true },
  { icon: Rocket, title: "Landing Pages", desc: "Focused pages designed to turn campaigns and ads into enquiries.", span: false },
  { icon: User, title: "Portfolio Websites", desc: "Showcase your work and craft with a site that feels like you.", span: false },
  { icon: ShoppingCart, title: "E-Commerce Websites", desc: "Online stores with product catalogues, cart and checkout.", span: false },
  { icon: AppWindow, title: "Web Applications", desc: "Dashboards, booking systems and custom tools built for your workflow.", span: true },
  { icon: RefreshCcw, title: "Website Redesign", desc: "A modern rebuild of an outdated site — same business, new presence.", span: false },
  { icon: Wrench, title: "Website Maintenance", desc: "Ongoing care plans that keep your site secure, fast and current.", span: false },
  { icon: PenLine, title: "Content Updates", desc: "Text, images, pages and announcements kept fresh for you.", span: false },
  { icon: Gauge, title: "Performance Optimization", desc: "Faster load times, better Core Web Vitals, happier visitors.", span: false },
  { icon: Search, title: "Basic SEO", desc: "On-page structure, metadata and indexing so customers can find you.", span: false },
];

export default function Services() {
  return (
    <section id="services" className="bg-[#070B16] py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <Eyebrow>Our Services</Eyebrow>
            <h2 className="max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
              Everything your business needs online, in one studio.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <button
              data-testid="services-cta-btn"
              onClick={() => scrollToId("contact")}
              className="group flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-[#00F0FF]/60 hover:text-[#00F0FF]"
            >
              Discuss your project
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-4 md:grid-cols-3 lg:grid-cols-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 0.08} className={s.span ? "md:col-span-2" : ""}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full rounded-2xl border border-white/10 bg-[#0A0F1C] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40"
              >
                <div className="mb-5 inline-flex rounded-xl border border-white/10 bg-white/5 p-3 text-[#00F0FF] transition-colors duration-300 group-hover:bg-[#00F0FF]/10">
                  <s.icon size={22} />
                </div>
                <h3 className="font-display text-lg font-bold text-white">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
